module.exports = __webpack_public_path__ + "img/profile-2.323ec16f.png";